<template>
  <!-- 全螢幕 Dialog，不會跳新頁也不是瀏覽器新視窗 -->
  <el-dialog
    title="儀器命名規則檢查"
    :visible.sync="visible"
    fullscreen
    :close-on-click-modal="false"
    @closed="$emit('close')"
  >
    <el-table
      v-loading="isLoading"
      :data="tableData"
      border
      style="width: 100%;"
    >
      <el-table-column
        prop="name"
        label="Instrument 名稱"
        min-width="300"
      />
      <el-table-column
        prop="match"
        label="是否符合命名規則"
        width="180"
      >
        <template #default="{ row }">
          <el-tag :type="row.match ? 'success' : 'danger'">
            {{ row.match ? '符合' : '不符合' }}
          </el-tag>
        </template>
      </el-table-column>
    </el-table>

    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">關閉</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'InstrumentNameChecker',
  props: {
    // 直接把外層傳進來的 project 物件拿來用
    project: { type: Object, required: true },
  },
  data() {
    return {
      visible: true,
      isLoading: false,
      tableData: [],
      regex: null,
    };
  },
  created() {
    console.log('project id', this.project);
    this.loadData();
  },
  methods: {
    /** 取得命名規則 (regex 字串) */
    async getProjectInstrumentNamedStyle() {
      let instrumentNamedStyle = this.project.instrumentNamedStyle;

      if (!instrumentNamedStyle) {
        instrumentNamedStyle = await this.$axios({
          category: 'project',
          method: 'get',
          apiName: `${this.project._id}/instrument-named-style`,
        });
      }
      return instrumentNamedStyle.data;
    },

    /** 主流程 */
    async loadData() {
      this.isLoading = true;
      try {
        // 1. 取 regex 字串並先編譯好
        const regexString = await this.getProjectInstrumentNamedStyle();
        this.regex = new RegExp(regexString);

        console.log(regexString);
        console.log(this.regex);

        // 2. 撈整棵 area-station-instrument 樹
        const res = await this.$axios({
          category: 'project',
          method: 'get',
          apiName: `${this.project._id}/area-station-instrument`,
        });

        console.log(res);

        let areas = res.data.area;

        // 3. 扁平化所有 instrument
        const instruments = [];
        areas.forEach(area => {
          area.station.forEach(st => {
            st.instrument.forEach(ins => instruments.push(ins));
          });
        });

        // 4. 組表
        this.tableData = instruments.map(ins => {
          const name = ins.latestVersion?.name || '(未命名)';
          const match = this.regex.exec(name);
          if(match) console.log(match);
          else console.error(name,'cannot match');
          return {
            name,
            match,
          };
        });
      } catch (err) {
        console.log(err);
        this.$notifyError(err);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
  